export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/hand_drawn.b4b43fa.svg";